<template>
  <div class="checklist">
    <draggable
      :list="formatData"
      :animation="200"
      ghost-class="ghost"
      @start="dragging = true"
      @end="dragging = false"
      :disabled='type!=="edit"'
    >
      <transition-group type="transition" :name="!dragging ? 'flip-list' : null">
        <div v-for="(item,index) in formatData" :key="index+'t'" :class="{'checkItem': true,'modified': item.modified}">
          <div :class="{'drag-line':true}"></div>
          <div class="itembox">
            <checkitem :index="index+1" :model="item" />
            <div class="itembox-button">
              <div v-if="type==='edit'" class="remove">
                <img
                  v-if="data.length>1"
                  src="../../assets/checklist/remove.png"
                  @click="removeItem(item)"
                />
              </div>
              <div v-if="type==='edit'" class="add">
                <img
                  v-if="index===data.length-1"
                  src="../../assets/checklist/add.png"
                  @click="addNewItem"
                />
              </div>
            </div>
          </div>
          <div :class="{'drag-line':true}"></div>
        </div>
      </transition-group>
    </draggable>
  </div>
</template>

<script>
import checkitem from "./checkitem";
import draggable from "vuedraggable";
export default {
  components: {
    checkitem: checkitem,
    draggable: draggable
  },
  props: {
    // edit(新增/修改),editview(审核查看),answer(作答状态),answerview(总查看)
    type: {
      type: String,
      default: "edit"
    },
    // 数据格式
    // {    content: "",//文本框内容
    //      type: "",  //同上面type可不填
    //      changeStatus: "new",  //暂时没用
    //      isNeedAttachments: false, //是否需要上传附件
    //      fileList: [], // （新增/编辑）文件列表 {filename:'文件名',filepath:'文件路径'}
    //      status: 1, //作答是选择状态 1,2,3
    //      answerfileList: [] //（作答）文件列表 {filename:'文件名',filepath:'文件路径'} }
    data: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      dragging: false
    };
  },
  computed: {
    formatData() {
      this.data.forEach(item => {
        if (this.type) {
          item.type = this.type;
        }
      });
      return this.data;
    }
  },
  watch: {},
  created() {
    this.data.forEach(item => {
      item.type = this.type;
    });
  },
  mounted() {},
  methods: {
    addNewItem() {
      this.data.push({
        Id: null,
        fileList: [],
        content: "",
        type: "edit",
        isNeedAttachments: false,
        isSchedule: false,
        status: null,
        changeStatus: "new"
      });
    },
    removeItem(item) {
      this.$confirm(
        this.$t("messageCommon.confirmDelete"),
        this.$t("checkList.tips"),
        {
          confirmButtonText: this.$t("checkList.confirm"),
          cancelButtonText: this.$t("checkList.cancel"),
          type: "warning"
        }
      ).then(() => {
        this.data.splice(this.data.indexOf(item), 1);
        this.$message({
          type: "success",
          message: this.$t("checkList.deleteSuccessful")
        });
      });
    }
  }
};
</script>
<style  scoped>
.itembox {
  display: flex;
}

.itembox-button {
  display: flex;
  align-items: flex-start;
}
.remove {
  display: flex;
  width: 22px;
  height: 22px;
  margin-left: 20px;
  margin-top: 2px;
}
.add {
  display: flex;
  width: 22px;
  height: 22px;
  margin-left: 20px;
  margin-right: 10px;
  margin-top: 2px;
}
.add img,
.remove img {
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.drag-line {
  height: 10px;
  margin: 1px 0;
}
.drag-line-color {
  background-color: #aaaaaa;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}

.checkItem{
  border: rgba(255, 255, 255, 0) solid 2px;
  margin-bottom: 5px;
}

.modified {
  /* background-color: rgba(255, 0, 0, 0.60); */
  border: rgba(255, 0, 0, 1) solid 2px;
}
</style>
